import { render } from "./QuizQrCode.vue?vue&type=template&id=1324911c&scoped=true"
import script from "./QuizQrCode.vue?vue&type=script&lang=js"
export * from "./QuizQrCode.vue?vue&type=script&lang=js"

import "./QuizQrCode.vue?vue&type=style&index=0&id=1324911c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1324911c"]])

export default __exports__